function sanitize(context) {
  // Remove all entries with null/undefined values.
  Object.entries(context).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      delete context[key];
    }
  });
}

export default class People {
  constructor() {
    this.userKey = null;
    Object.preventExtensions(this);
  }

  setUserKey(userKey) {
    this.userKey = userKey;
    return this;
  }

  build() {
    sanitize(this);
    return Object.freeze(this);
  }
}



// WEBPACK FOOTER //
// ./src/Telemetry/Mixpanel/Model/people.js